import React from "react";

const COLORS = ["#0B3D3D", "#C24127", "#B45309", "#1D4E89", "#6B3FA0", "#1E7A34", "#8A5A2B"];

function hashColor(s) {
  let h = 0;
  for (let i = 0; i < (s || "").length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length];
}

function initials(name) {
  const p = (name || "").trim().split(/\s+/);
  if (!p[0]) return "?";
  return ((p[0][0] || "") + (p[1]?.[0] || "")).toUpperCase();
}

export default function UserAvatar({ name, avatar, size = 40 }) {
  const s = { width: size, height: size };
  if (avatar && avatar.startsWith("av")) {
    return (
      <img src={`/avatars/${avatar}.jpg`} alt={name || "avatar"} style={s}
           className="rounded-full object-cover shrink-0 border border-black/5" data-testid="user-avatar-img" />
    );
  }
  return (
    <div style={{ ...s, backgroundColor: hashColor(name), fontSize: size * 0.4 }}
         className="rounded-full flex items-center justify-center text-white font-semibold shrink-0"
         data-testid="user-avatar-monogram">
      {initials(name)}
    </div>
  );
}
